<template>
  <div :class="{ __disabled: disabled }" class="select">
    <div @click="toggle" class="select_label">
      <div>
        {{ getLabel(value) || "ระบุ" }}
      </div>
      <img
        class="arrow-down-white"
        src="@/assets/icons/arrow-down-dropdown-text2.svg"
        alt="arrow-down-dropdown-white"
      />
      <img
        class="arrow-down-text2"
        src="@/assets/icons/arrow-down-dropdown-text2.svg"
        alt="arrow-down-dropdown-text2"
      />
    </div>
    <div v-if="opened" class="select_options">
      <div
        v-for="(opt, index) in options"
        v-bind:key="index"
        :value="getVal(value)"
        @click="change(opt.value)"
        :class="{ __active: getVal(opt) == getVal(value) }"
        class="select_option"
      >
        {{ getLabel(opt.value) }}
      </div>
    </div>
    <div v-if="opened" @click="toggle" class="select_overlay"></div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  data() {
    return {
      opened: false,
    };
  },

  props: {
    value: {
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    valueKey: {
      type: String,
      required: false,
    },
    labelKey: {
      type: String,
      required: false,
    },
    onChange: {
      type: Function,
      required: false,
    },
    disabled: {
      type: Boolean,
    },
  },

  methods: {
    getVal(val) {
      const data = this.options.find((v) => v.value === val) || "";
      return data.value;
    },
    getLabel(val) {
      const data = this.options.find((v) => v.value === val) || "";
      return data.lable;
    },
    change(val) {
      this.$emit("input", val);
      this.opened = false;

      if (this.onChange !== undefined) {
        this.onChange(val);
      }
    },
    toggle() {
      if (this.disabled) {
        return;
      }
      this.opened = !this.opened;
    },
  },
};
</script>

<style scoped>
.select {
  display: flex;
  position: relative;
  justify-content: center;
  height: 56px;
  width: 100%;
  max-width: 352px;
  box-sizing: border-box;
}

.select_label {
  color: #393d43;
  display: flex;
  cursor: pointer;
  transition: color ease-in-out 0.05s;
  white-space: nowrap;
  position: relative;
  padding: 3px 18px 3px 12px;

  border-radius: 5px;
  border: 1px solid #acb1bf;
  background: transparent;

  height: 100%;
  width: 100%;
  max-width: 352px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
}

.select_label:hover {
  border-color: #29a9e2;
  color: #393d43;
}

.arrow-down-white {
  display: none;
}
.select_label:hover .arrow-down-text2 {
  display: none;
}
.select_label:hover .arrow-down-white {
  display: block;
}

.select_options {
  position: absolute;
  border: 1px solid #acb1bf;
  background: #ffffff;
  border-radius: 5px;
  z-index: 1001;
  top: 56px;
  width: 100%;
}
.select_option {
  cursor: default;
  color: #393d43;
  padding: 7px 13px;
  white-space: nowrap;
  text-align: left;
  height: 56px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.select_option:first-child {
  border-radius: 2px 2px 0 0;
}
.select_option:last-child {
  border-radius: 0 0 2px 2px;
}
.select_option:hover {
  background: #29a9e2;
}
.select_overlay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1000;
}

.__disabled {
  opacity: 0.5;
}
/* .__disabled &_label:hover {
  color: #4c4c4c;
  cursor: default;
} */
</style>
